import { SELF_CLOSING_TAGS } from './components.constants';

export interface Style {
    [key: string]: string;
}

export interface AdditionalStyleSheet {
    style: Style;
}

export interface MandatoryAdditionalStyle {
    additionalStyle: AdditionalStyleSheet;
}

export interface OptionalAdditionalStyle {
    additionalStyle?: AdditionalStyleSheet;
}

export const isSelfClosingTag = (tagName: string) => SELF_CLOSING_TAGS.includes(tagName.toLowerCase());

export const extractWrapperAndContentFromHtml = (html: string) => {
  const regex = /^<(\w+).*?>/;
  const match = html.match(regex);

  if (!match || isSelfClosingTag(match[1])) {
    return { wrapper: 'p', content: html };
  }

  const indexOfLastElement = html.lastIndexOf('<');
  return {
    wrapper: match[1],
    content: html.substring(0, indexOfLastElement).replace(match[0], ''),
  };
};

export const injectScriptTagToHead = (scriptSrc: string, type?: string) => {
  const script = document.createElement('script');
  script.src = scriptSrc;
  script.async = true;
  if (type) script.type = type;
  document.head.appendChild(script);
};
